var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getAgent
    ? _c(
        "div",
        [
          _c(
            "v-form",
            { attrs: { "lazy-validation": "" } },
            [
              _c(
                "v-row",
                { staticClass: "text-left py-2" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pb-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "py-0", attrs: { cols: "6" } },
                            [
                              _c("label", { attrs: { for: "etiqueta" } }, [
                                _vm._v("Etiqueta"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { staticClass: "pa-0", attrs: { cols: "6" } },
                            [_c("TagModal")],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-combobox", {
                        staticClass: "h-auto pt-0",
                        attrs: {
                          id: "etiqueta",
                          items: _vm.getActiveTags,
                          chips: "",
                          multiple: "",
                          "item-id": "name",
                          "item-text": "name",
                          "return-object": "",
                          solo: "",
                          "hide-details": "",
                        },
                        on: {
                          focus: function ($event) {
                            _vm.comboboxOpen = true
                          },
                          blur: function ($event) {
                            _vm.comboboxOpen = false
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function ({ attrs, item, select, selected }) {
                                return [
                                  _c(
                                    "v-chip",
                                    _vm._b(
                                      {
                                        attrs: {
                                          "input-value": selected,
                                          color: item.color,
                                        },
                                        on: {
                                          click: select,
                                          "click:close": function ($event) {
                                            return _vm.removeTag(item)
                                          },
                                        },
                                      },
                                      "v-chip",
                                      attrs,
                                      false
                                    ),
                                    [
                                      _c("strong", [_vm._v(_vm._s(item.name))]),
                                      _vm._v(
                                        "\n               \n              "
                                      ),
                                      _c("span"),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "no-data",
                              fn: function () {
                                return [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                  El tag no existe. Presiona\n                  "
                                            ),
                                            _c("kbd", [_vm._v("enter")]),
                                            _vm._v(
                                              "\n                  para crearlo.\n                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1572579853
                        ),
                        model: {
                          value: _vm.tags,
                          callback: function ($$v) {
                            _vm.tags = $$v
                          },
                          expression: "tags",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }